import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import { calculateColumnTotal } from "../General/Utility";

const FeeDetails = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [feeTypeName, setFeeTypeName] = useState("");

  const urlParams = new URLSearchParams(window.location.search);
  const ReportYear = urlParams.get("ReportYear");
  const ReportMonth = urlParams.get("ReportMonth");
  const FeeCode = urlParams.get("FeeCode");
  const FeeTypeId = urlParams.get("FeeTypeId");

  useEffect(() => {
    document.title = "Fee Details";

    if (!ReportYear || !ReportMonth || (!FeeCode && !FeeTypeId)) {
      setLoading(false);
      return;
    }

    setLoading(true);

    const data = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      ReportMonth: ReportMonth,
      ReportYear: ReportYear,
      FeeCode: FeeCode || "",
      FeeTypeId: FeeTypeId ? parseInt(FeeTypeId, 10) : 0,
      pageSize: 10000,
    };

    axios({
      method: "post",
      url: config.base_url + "Reports/GetFeeCollectionDetails",
      headers: { "Content-Type": "application/json" },
      data: data,
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setLedger(response.data.ListofRecords || []);
          setTotalRecords(response.data.totalRecords || 0);
          setTotalAmount(
            response.data.totalAmount != null
              ? response.data.totalAmount
              : 0
          );
          setFeeTypeName(
            response.data.Fee_Type_Name ||
              response.data.FeeCode ||
              FeeCode ||
              ""
          );
        } else {
          setLedger([]);
        }
        setLoading(false);
      })
      .catch(function () {
        setLoading(false);
      });
  }, []);

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{item.Serial_No}</td>
          <td>{item.Registration_No}</td>
          <td>{item.Student_ID}</td>
          <td>{item.Fee_Type_Code}</td>
          <td>{item.Fee_Type_Name}</td>
          <td>{item.Student_Name}</td>
          <td>{item.selectedMonth}</td>
          <td>{item.selectedYear}</td>
          <td>{item.Amount}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="9">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  const title = `Fee Details — ${feeTypeName || FeeCode || ""} (${ReportMonth}/${ReportYear})`;

  return (
    <Page orientation="portrait" size="a4">
      <PrintHeader title={title} />
      <table className="table table-sm table-bordered table-print">
        <thead>
          <tr>
            <th>Serial No</th>
            <th>Reg No</th>
            <th>Student ID</th>
            <th>Fee Code</th>
            <th>Fee Type</th>
            <th>Student Name</th>
            <th>Month</th>
            <th>Year</th>
            <th>Amount</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td className="text-center" colSpan="9">
                <Spinner animation="border" role="status" />
              </td>
            </tr>
          ) : (
            <>
              {renderLedger()}
              {listOfLedger.length > 0 && (
                <tr className="fw-semibold">
                  <td colSpan={8} className="text-end">
                    Total
                  </td>
                  <td>
                    {totalAmount > 0
                      ? totalAmount
                      : calculateColumnTotal(listOfLedger, "Amount")}
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    </Page>
  );
};

export default FeeDetails;
